module.exports = __webpack_public_path__ + "img/2-Cert.6de88240.jpg";